import React from 'react';
import { Container } from './styles';

interface TooltipProps {
  title: string;
  className?: string;
  status?: string;
}

const Tooltip: React.FC<TooltipProps> = ({
  title,
  className = '',
  status = '',
  children,
}) => {
  return (
    <Container className={className} status={status} title={title}>
      {children}
      <span>{title}</span>
    </Container>
  );
};

export default Tooltip;
